import React from 'react';
import { string, shape, bool } from 'prop-types';
import GoogleIcon from 'components/google-icon';

export default function EventListing({ item }) {
    const eventTime = item.pastEvent ? <strong>Event now closed</strong> : item.time;
    return (
        <div className="c-event-listing">
            <div className="event-listing-wrapper">
                <div className="event-blurb">
                    <div className="event-media-wrapper">
                        {item.isSelling || item.isSold || item.pastEvent ?
                            <span className={`event-state ${item.isSelling ? 'sell-out' : ''} ${item.isSold ? 'sold-out' : ''} ${item.pastEvent ? 'past-event' : ''}`}>{item.eventStateTxt}</span> : false
                        }
                        <a href={item.url} className={`ratio-wrapper ${item.imageAlign || ''}`} style={{ backgroundImage: `url('${item.thumbnail}')` }}>
                            <img src={item.thumbnail} alt={item.title} />
                        </a>
                    </div>
                    <div className="event-text-wrapper">
                        <h2><a href={item.url}>{item.title}</a></h2>
                        {item.paragraph &&
                            <p>{item.paragraph}</p>
                        }
                    </div>
                </div>
                <div className="event-details">
                    <div className="event-list-details">
                        {item.date &&
                            <div className="event-list-details-item">
                                <GoogleIcon icon="calendar_today" />
                                <span>{item.date}</span>
                            </div>
                        }
                        {item.location && (
                            item.map ? (
                                <div className="event-list-details-item">
                                    <GoogleIcon icon="location_on" />
                                    <a href={item.map} target="_blank" >{item.location}</a>
                                </div>
                            ) : (
                                <div className="event-list-details-item">
                                    <GoogleIcon icon="location_on" />
                                    <span>{item.location}</span>
                                </div>
                            )
                        )}
                        {item.time &&
                            <div className={`event-list-details-item ${item.pastEvent ? 'event-closed' : ''}`}>
                                <GoogleIcon icon="access_time" />
                                <span>{eventTime}</span>
                            </div>
                        }
                        {(!item.pastEvent && item.price) &&
                            <div className="event-list-details-item">
                                <GoogleIcon icon="attach_money" />
                                {item.price}
                            </div>
                        }
                    </div>
                    <div className="event-links">
                        {!item.pastEvent &&
                            <a href={item.eventLink} className="btn-skin-1 btn-small">Register Now</a>
                        }
                        <a href={item.url} title={item.title} className="btn-skin-2 btn-small">Find Out More</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

EventListing.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        title: string.isRequired,
        date: string,
        map: string,
        location: string,
        time: string,
        price: string,
        thumbnail: string,
        imageAlign: string,
        isSelling: bool,
        isSold: bool,
        pastEvent: bool,
        eventStateTxt: string,
        eventLink: string,
        paragraph: string
    }).isRequired
    /* eslint-enable react/no-typos */
};
